<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <span>© Tapes To Digital · {{ company }}</span>
      <span class="site-footer__links">
        <a :href="website + '/privacy-policy'">Privacy</a>
        <a :href="website + '/pricing'">Pricing</a>
        <a :href="website + '/locations'">All locations</a>
      </span>
    </div>
  </footer>
</template>

<script>
import { market } from "@/utils/market";

export default {
  data: () => ({
    website: market().website,
    company: market().company,
  }),
};
</script>

<style scoped>
.site-footer {
  margin-top: auto;
  border-top: 1px solid #e3e7ea;
  background: #ffffff;
}
.site-footer__inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: #5b6168;
}
.site-footer__links {
  display: flex;
  gap: 18px;
}
@media (max-width: 600px) {
  .site-footer__inner {
    padding: 18px 16px;
  }
}
</style>
